module.exports = __webpack_public_path__ + "img/lashousuo.dce6bc2f.jpg";